import api from '.';

export function listar(grupoId) {
    return api.get(`/grupo/${grupoId}/subgrupos`);
}

export function cadastrar(grupoId, dados) {
    return api.post(`/grupo/${grupoId}/subgrupos/cadastrar`, dados);
}

export function editar(grupoId, subGrupoUuid, dados) {
    return api.put(`/grupo/${grupoId}/subgrupos/${subGrupoUuid}`, dados);
}

export function excluir(grupoId, subGrupoUuid) {
    return api.delete(`/grupo/${grupoId}/subgrupos/${subGrupoUuid}`);
}
